module.exports = __webpack_public_path__ + "static/media/comfirmBg@2x.07a307fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/comfirmBg@2x.png
// module id = 401
// module chunks = 0